module.exports = __webpack_public_path__ + "static/media/cardNine.00fe244d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardNine.jpg
// module id = 91
// module chunks = 0